import { FC } from 'react';

type Props = {
  searchTerm: string;
};

const NoSearchResults: FC<Props> = ({ searchTerm }) => {
  return (
    <div className="relative">
      <div className="absolute z-50 mt-3 left-0 w-full bg-grey10 shadow-bs80 max-h-xl overflow-y-auto rounded-md overflow-hidden p-3">
        Din sökning på <span className="font-icb">{searchTerm}</span> gav inga
        resultat.
      </div>
    </div>
  );
};

export default NoSearchResults;
